import { useCallback, useState } from 'react';
import type { GuaArticle } from '@/mocks/gua88-news';
import StickyNav from './components/StickyNav';
import Hero from './components/Hero';
import Latest from './components/Latest';
import Feed from './components/Feed';
import Timeline from './components/Timeline';
import Talk from './components/Talk';
import Faq from './components/Faq';
import About from './components/About';
import Subscribe from './components/Subscribe';
import SiteFooter from './components/SiteFooter';
import BackTop from './components/BackTop';
import ArticleModal from './components/ArticleModal';

export default function Home() {
  const [query, setQuery] = useState('');
  const [active, setActive] = useState<GuaArticle | null>(null);

  const onSearch = useCallback((q: string) => {
    setQuery(q);
    const el = document.getElementById('feed');
    el?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  const openArticle = useCallback((a: GuaArticle) => setActive(a), []);
  const closeArticle = useCallback(() => setActive(null), []);

  return (
    <main className="min-h-screen bg-background-50">
      <StickyNav />
      <Hero onSearch={onSearch} />
      <Latest onRead={openArticle} />
      <Feed query={query} onRead={openArticle} />
      <Timeline />
      <Talk />
      <Faq />
      <About />
      <Subscribe />
      <SiteFooter />
      <BackTop />
      <ArticleModal article={active} onClose={closeArticle} />
    </main>
  );
}